import { DayProgram } from './day-program.model';
import { AreaProgram } from './area.program.model';

export class Congresso {
    public Id: number;
    public Descricao: string;
    public Ano: number;
    public IsOnline: boolean;
    public Liberado: boolean;
    public Atual: boolean;
    public CorPrimaria: string;
    public CorSecundaria: string;
    public CorTerciaria:string;
    public NumeroInscritos: number;
    public NumeroVisualizacoes: number;
    public AtividadesDia: Array<DayProgram>;
    public AtividadesArea: Array<AreaProgram>;
}



// WEBPACK FOOTER //
// ./src/models/congresso.model.ts